// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./BoxTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS implementation */
/* stylelint-disable declaration-property-value-disallowed-list -- using new ds colors */

.Box-module__Container__yhZZC {
    display: flex;
    min-width: 0;
}

.Box-module__Flex__W8JpF {
    background: transparent;
}

.Box-module__Level1__XWCmX {
    background-color: var(--ds-box-level1-bg-color);
}

.Box-module__Level2__flJ64 {
    background-color: var(--ds-box-level2-bg-color);
    border: var(--ds-border-width) solid var(--ds-box-level2-border-color);
}

.Box-module__Level2a__PIaVG {
    background: var(--ds-box-level2a-bg-color);
    border: var(--ds-border-width) solid var(--ds-box-level2a-border-color);
}

.Box-module__Level3__HCOn6 {
    background-color: var(--ds-box-level3-bg-color);
    border: var(--ds-border-width-double) solid
        var(--ds-box-level3-border-color);
}

.Box-module__Level4__P_Ajn {
    background-color: var(--ds-box-level4-bg-color);
    border: var(--ds-border-width-double) solid
        var(--ds-box-level4-border-color);
}

.Box-module__NoBorder__YNWrn {
    border: none;
}

.Box-module__Muted__jjPNM {
    opacity: 0.5;
}

.Box-module__ScrollableY__bzu0n {
    justify-content: flex-start;
    height: auto;
    overflow-y: auto;
}

.Box-module__Gap2XS__I9htA {
    gap: var(--ds-2xs);
}

.Box-module__GapXS__OR1sp {
    gap: var(--ds-xs);
}

.Box-module__GapS__LgD__ {
    gap: var(--ds-s);
}

.Box-module__GapSM__zdAu_ {
    gap: var(--ds-sm);
}

.Box-module__GapM__lS4ao {
    gap: var(--ds-m);
}

.Box-module__GapL__BezoY {
    gap: var(--ds-l);
}

.Box-module__GapXL__hPjMT {
    gap: var(--ds-xl);
}

.Box-module__Gap2XL__DLAY6 {
    gap: var(--ds-2xl);
}

.Box-module__Gap3XL__W0Ayj {
    gap: var(--ds-3xl);
}

.Box-module__Gap10x__fuxHr {
    gap: var(--ds-10x);
}

.Box-module__Gap36x__iCNqK {
    gap: var(--ds-36x);
}
/* Positioning */
/* Border Radius */
.Box-module__Radius2XS__mAxFo {
    border-radius: var(--ds-2xs);
}

.Box-module__RadiusXS__KLqem {
    border-radius: var(--ds-xs);
}

.Box-module__RadiusS__lfRRI {
    border-radius: var(--ds-s);
}

.Box-module__RadiusSM__nTgs9 {
    border-radius: var(--ds-sm);
}

.Box-module__RadiusM___EQlt {
    border-radius: var(--ds-m);
}

.Box-module__RadiusL__Ho9Uq {
    border-radius: var(--ds-l);
}

.Box-module__RadiusXL__pNOZA {
    border-radius: var(--ds-xl);
}

.Box-module__Radius2XL__JAoSw {
    border-radius: var(--ds-2xl);
}

.Box-module__Radius3XL__jyOlH {
    border-radius: var(--ds-3xl);
}

.Box-module__Radius10x__AaTe5 {
    border-radius: var(--ds-10x);
}

.Box-module__Radius36x__kTLh2 {
    border-radius: var(--ds-36x);
}
/* Border Radius */
/* Orientation */
.Box-module__Row__IWTMb {
    flex-direction: row;
}

.Box-module__Column__IFzXk {
    flex-direction: column;
}
/* Orientation */
/* Alignments */
.Box-module__JustifyStart__z9i57 {
    justify-content: flex-start;
}

.Box-module__JustifyCenter__FUSwu {
    justify-content: center;
}

.Box-module__JustifyBetween__ajZDx {
    justify-content: space-between;
}

.Box-module__JustifyEnd__rLtxM {
    justify-content: flex-end;
}

.Box-module__AlignStart__UGa8m {
    align-items: flex-start;
}

.Box-module__AlignCenter__xXlGd {
    align-items: center;
}

.Box-module__AlignEnd__M71NL {
    align-items: flex-end;
}
/* Alignments */

.Box-module__Wrap__g6SfF {
    flex-wrap: wrap;
}
/* Full Width */
.Box-module__FullWidth__fCYYx {
    width: 100%;
}
/* Full Height */
.Box-module__FullHeight__ozBYb {
    height: 100%;
}

.Box-module__VisuallyHidden__Uwtfu {
    position: absolute;
    left: -10000px;
    width: 1px;
    height: 1px;
    overflow: hidden;
}

.Box-module__ShadowShallow__RaZKa {
    box-shadow: var(--ds-shadow-shallow);
}

.Box-module__ShadowDeep__CTlLr {
    box-shadow: var(--ds-shadow-deep);
}

.Box-module__AllowShrink___B1tK {
    flex-shrink: 1;
}

.Box-module__PreventShrink__trGrP {
    flex-shrink: 0;
}

.Box-module__AllowGrow__ZXUBA {
    flex-grow: 1;
}

.Box-module__PreventGrow__M7_Zx {
    flex-grow: 0;
}

.Box-module__WidthXXS__fg3h4 {
    width: var(--ds-40x);
}

.Box-module__WidthXS__paXB5 {
    width: var(--ds-64x);
}

.Box-module__WidthS__BgWpM {
    width: var(--ds-75x);
}

.Box-module__WidthSM__nKFWn {
    width: var(--ds-100x);
}

.Box-module__WidthM__UVIU0 {
    width: var(--ds-137x);
}

.Box-module__WidthL__e4rSf {
    width: var(--ds-160x);
}

.Box-module__WidthXL__uSXBq {
    width: var(--ds-190x);
}

.Box-module__Width2XL__yUYBq {
    width: var(--ds-320x);
}

.Box-module__BasisXXS__bPZVw {
    flex-basis: var(--ds-40x);
}

.Box-module__BasisXS__U2pNE {
    flex-basis: var(--ds-64);
}

.Box-module__BasisS__ta2uA {
    flex-basis: var(--ds-75x);
}

.Box-module__BasisSM__Yx2tt {
    flex-basis: var(--ds-100x);
}

.Box-module__BasisM__bO0Wr {
    flex-basis: var(--ds-137x);
}

.Box-module__BasisL__jceA2 {
    flex-basis: var(--ds-160x);
}

.Box-module__BasisXL__Hr9V1 {
    flex-basis: var(--ds-190x);
}

.Box-module__Basis2XL__K5N7P {
    flex-basis: var(--ds-320x);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Box-module__Container__yhZZC`,
	"Flex": `Box-module__Flex__W8JpF`,
	"Level1": `Box-module__Level1__XWCmX`,
	"Level2": `Box-module__Level2__flJ64`,
	"Level2a": `Box-module__Level2a__PIaVG`,
	"Level3": `Box-module__Level3__HCOn6`,
	"Level4": `Box-module__Level4__P_Ajn`,
	"NoBorder": `Box-module__NoBorder__YNWrn`,
	"Muted": `Box-module__Muted__jjPNM`,
	"ScrollableY": `Box-module__ScrollableY__bzu0n`,
	"Gap2XS": `Box-module__Gap2XS__I9htA`,
	"GapXS": `Box-module__GapXS__OR1sp`,
	"GapS": `Box-module__GapS__LgD__`,
	"GapSM": `Box-module__GapSM__zdAu_`,
	"GapM": `Box-module__GapM__lS4ao`,
	"GapL": `Box-module__GapL__BezoY`,
	"GapXL": `Box-module__GapXL__hPjMT`,
	"Gap2XL": `Box-module__Gap2XL__DLAY6`,
	"Gap3XL": `Box-module__Gap3XL__W0Ayj`,
	"Gap10x": `Box-module__Gap10x__fuxHr`,
	"Gap36x": `Box-module__Gap36x__iCNqK`,
	"Radius2XS": `Box-module__Radius2XS__mAxFo`,
	"RadiusXS": `Box-module__RadiusXS__KLqem`,
	"RadiusS": `Box-module__RadiusS__lfRRI`,
	"RadiusSM": `Box-module__RadiusSM__nTgs9`,
	"RadiusM": `Box-module__RadiusM___EQlt`,
	"RadiusL": `Box-module__RadiusL__Ho9Uq`,
	"RadiusXL": `Box-module__RadiusXL__pNOZA`,
	"Radius2XL": `Box-module__Radius2XL__JAoSw`,
	"Radius3XL": `Box-module__Radius3XL__jyOlH`,
	"Radius10x": `Box-module__Radius10x__AaTe5`,
	"Radius36x": `Box-module__Radius36x__kTLh2`,
	"Row": `Box-module__Row__IWTMb`,
	"Column": `Box-module__Column__IFzXk`,
	"JustifyStart": `Box-module__JustifyStart__z9i57`,
	"JustifyCenter": `Box-module__JustifyCenter__FUSwu`,
	"JustifyBetween": `Box-module__JustifyBetween__ajZDx`,
	"JustifyEnd": `Box-module__JustifyEnd__rLtxM`,
	"AlignStart": `Box-module__AlignStart__UGa8m`,
	"AlignCenter": `Box-module__AlignCenter__xXlGd`,
	"AlignEnd": `Box-module__AlignEnd__M71NL`,
	"Wrap": `Box-module__Wrap__g6SfF`,
	"FullWidth": `Box-module__FullWidth__fCYYx`,
	"FullHeight": `Box-module__FullHeight__ozBYb`,
	"VisuallyHidden": `Box-module__VisuallyHidden__Uwtfu`,
	"ShadowShallow": `Box-module__ShadowShallow__RaZKa`,
	"ShadowDeep": `Box-module__ShadowDeep__CTlLr`,
	"AllowShrink": `Box-module__AllowShrink___B1tK`,
	"PreventShrink": `Box-module__PreventShrink__trGrP`,
	"AllowGrow": `Box-module__AllowGrow__ZXUBA`,
	"PreventGrow": `Box-module__PreventGrow__M7_Zx`,
	"WidthXXS": `Box-module__WidthXXS__fg3h4`,
	"WidthXS": `Box-module__WidthXS__paXB5`,
	"WidthS": `Box-module__WidthS__BgWpM`,
	"WidthSM": `Box-module__WidthSM__nKFWn`,
	"WidthM": `Box-module__WidthM__UVIU0`,
	"WidthL": `Box-module__WidthL__e4rSf`,
	"WidthXL": `Box-module__WidthXL__uSXBq`,
	"Width2XL": `Box-module__Width2XL__yUYBq`,
	"BasisXXS": `Box-module__BasisXXS__bPZVw`,
	"BasisXS": `Box-module__BasisXS__U2pNE`,
	"BasisS": `Box-module__BasisS__ta2uA`,
	"BasisSM": `Box-module__BasisSM__Yx2tt`,
	"BasisM": `Box-module__BasisM__bO0Wr`,
	"BasisL": `Box-module__BasisL__jceA2`,
	"BasisXL": `Box-module__BasisXL__Hr9V1`,
	"Basis2XL": `Box-module__Basis2XL__K5N7P`
};
export default ___CSS_LOADER_EXPORT___;
